"use client";
import { useScrollToTop } from "@/hooks";
import { useSelector } from "react-redux";
import { isObjEmpty } from "@/utils";
import { Domain } from "./Domain";
import dynamic from "next/dynamic";
import { useEffect, useState } from "react";
import { Testimonials } from "./Testimonials/Testimonials";
import { OurTeam } from "@/components/OurTeam";
import BlogHomePage from "./Blog/BlogHomePage";
import { StartUpHomePage } from "./Startup/StartUpHomePage";
import PortfolioProjects from "./PortfolioProjects";
import HostingPackages from "./HostingPackages";
import Stats from "./Stats";
import SocialMediaSlider from "./SocialMediaSlider/SocialMediaSlider";

const DomainSearchResult = dynamic(() => import("./DomainSearchResult"), {
  ssr: false,
});


export const HomeDomain = ({nameSite,currency,default_currency}) => {
  const [shown, setShown] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY >= 50) {
        setShown(true);
      }
    };
    window.addEventListener("scroll", onScroll);

    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, []);
  useScrollToTop();
  const { enteredDomainRes } = useSelector((state) => state.domain);
  const hasDomainRes = isObjEmpty(enteredDomainRes);

  return (
    <div>
      <Domain currency={currency} default_currency={default_currency} nameSite={nameSite} sectionName="home" />
      <div className="w-12 h-1 scrollNew opacity-0 text-black">fake</div>
      {!hasDomainRes && <DomainSearchResult />}
      <HostingPackages />
      <StartUpHomePage />
      <Stats />
      {<OurTeam />}
      {<PortfolioProjects />}
      {<Testimonials />}
      {<BlogHomePage />}
      {<SocialMediaSlider />}
    </div>
  );
};
